import { render, staticRenderFns } from "./AddBusinessContact.vue?vue&type=template&id=933d1242&"
import script from "./AddBusinessContact.vue?vue&type=script&lang=js&"
export * from "./AddBusinessContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QForm,QItemLabel,QInput,QCardActions,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QForm,QItemLabel,QInput,QCardActions,QBtn})
